export default () => {
  document.getElementById('file-picker')?.click();
};
